import { createSlice } from '@reduxjs/toolkit';

import {
  organicCreditAndAutoOriginationCheck,
  refiCreditCheck,
  refiAutoOriginationCheck,
  runSnowflakeRefiScore,
  runSnowflakeRefiReloanScore,
  getCurrentApplication,
  handleDocumentsUploaded,
  logout,
  saveAutoPayOption,
  saveBankInformation,
  saveIncomeSources,
  saveSelectedOffer,
  selectBankAccount,
  saveTermsOfUseAcceptance,
  wellsFargoCheck,
  updateOrganicLoanOfferViewed,
  runSecondChanceCashflowAndAutoOrigination,
  handleDeclineApplication,
  runPreliminaryCheck,
} from 'thunks';
import { ICuroApplication } from 'types/curo/CuroApplication';

import { resetCuroStore } from './actions';

export interface IApplicationProcessState {
  application: ICuroApplication | null;
}

const initialState: IApplicationProcessState = {
  application: null,
};

const applicationProcessSlice = createSlice({
  name: 'applicationProcess',
  initialState,
  reducers: {
    resetApplication: (state) => {
      state.application = null;
    },
  },
  extraReducers: (builder) => {
    [
      getCurrentApplication.fulfilled,
      runSnowflakeRefiScore.fulfilled,
      runSnowflakeRefiReloanScore.fulfilled,
      saveIncomeSources.fulfilled,
      saveBankInformation.fulfilled,
      saveTermsOfUseAcceptance.fulfilled,
      handleDocumentsUploaded.fulfilled,
      wellsFargoCheck.fulfilled,
      saveSelectedOffer.fulfilled,
      selectBankAccount.fulfilled,
      organicCreditAndAutoOriginationCheck.fulfilled,
      refiCreditCheck.fulfilled,
      refiAutoOriginationCheck.fulfilled,
      saveAutoPayOption.fulfilled,
      updateOrganicLoanOfferViewed.fulfilled,
      runSecondChanceCashflowAndAutoOrigination.fulfilled,
      handleDeclineApplication.fulfilled,
      runPreliminaryCheck.fulfilled,
    ].map((thunk) =>
      builder.addCase(thunk, (state, { payload }) => {
        state.application = payload;
      }),
    );
    [logout.rejected, logout.fulfilled, resetCuroStore].map((thunk) =>
      builder.addCase(thunk, () => initialState),
    );
  },
});

export const { resetApplication } = applicationProcessSlice.actions;
export default applicationProcessSlice.reducer;
